import mediaReducer from '@sophocles/features/media/slice';

export default mediaReducer;
